import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import 'ant-design-vue/dist/antd.less'
import 'babel-polyfill'
import VueAnalytics from 'vue-analytics'
// import ReportAecore from "@/utils/reportAecore"; //引入
import Button from 'ant-design-vue/lib/button';
import Space from 'ant-design-vue/lib/space';
Vue.component(Button.name, Button);
Vue.component(Space.name, Space);
// Vue.prototype.reportAecore = ReportAecore;

// ReportAecore.listen();

// ReportAecore.changeApi();

Vue.use(VueAnalytics, {
  id: 'UA-82121871-5',
  router
})

Vue.config.productionTip = false
Vue.use(router)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
